import { Box, Heading, Table, Tbody, Td, Th, Thead, Tr, VStack, Spinner, Link } from "@chakra-ui/react";
import Layout from "../components/layouts/main";
import { useEffect, useState } from "react";
import api from "../utils/axios";
import { formatNumber } from "../utils/helper";
import { motion } from "framer-motion";
import { useAccount } from "wagmi";
import Pagination from "../components/Pagination"; // Импортируем наш компонент

const MotionHeading = motion(Heading);

const Top100Page = () => {
	const [data, setData] = useState([]);
	const { address } = useAccount();
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 10;
	const [loading, setLoading] = useState(true);


	useEffect(() => {
		const fetchTopAddresses = async () => {
			setLoading(true);
			try {
				const response = await api.get('/top-addresses');
				setData(response.data);
			} catch (error) {
				console.error('Error fetching top addresses:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchTopAddresses();
	}, [address]);

	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

	const totalPages = Math.ceil(data.length / itemsPerPage);

	return (
		<Layout>
			<Box padding={4} width="100%" margin="0 auto" id="rank">
				<VStack spacing={6} align="center">
					<MotionHeading
						fontSize="clamp(1.5em, 2.8vw, 2.4em)"
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
						textAlign={"center"}
						m={1}
					>
						Top 100 Addresses
					</MotionHeading>
				</VStack>
				{loading ? (
					<Box display="flex" alignItems="center" justifyContent="center" height={"100%"} pt={16}>
						<Spinner size="xl" color='#FF684B' thickness="4px" />
					</Box>
				) : (
					<Box mt={6} borderRadius="lg" padding={4} width="100%" maxW="700px" mx="auto">
						<Box overflowX="auto">
							<Table variant="simple" width="100%" fontSize="sm">
								<Thead>
									<Tr>
										<Th>Rank</Th>
										<Th>Address</Th>
										<Th>Badges</Th>
										<Th>Average Daily</Th>
										<Th isNumeric>Marks</Th>
									</Tr>
								</Thead>
								<Tbody>
									{currentItems.map((item, index) => (
										<Tr key={index}>
											<Td>#{indexOfFirstItem + index + 1}</Td>
											<Td><Link isExternal color={"#FF684B"} href={`https://debank.com/profile/${item.address}?chain=scrl`}>{item.address.slice(0, 6)}...{item.address.slice(-4)}</Link></Td>
											<Td>{item.badgeCount}</Td>
											<Td>+{formatNumber(item.averageDailyIncrease)}</Td>
											<Td isNumeric>{formatNumber(parseFloat(item.points))}</Td>
										</Tr>
									))}
								</Tbody>
							</Table>
						</Box>
					</Box>
				)}
				<Pagination
					currentPage={currentPage}
					totalPages={totalPages}
					onPageChange={setCurrentPage}
				/>
			</Box>
		</Layout>
	);
};

export default Top100Page;
